"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStackedChart = exports.transformToDualAxesSeries = exports.createDualAxesSeriesMapper = exports.getComboChartSeries = exports.groupSeriesItemsByType = exports.LEGEND_SEPARATOR = exports.LEGEND_AXIS_INDICATOR = exports.calculateStaticLegend = exports.calculateFluidLegend = exports.UTF_NON_BREAKING_SPACE = exports.SKIPPED_LABEL_TEXT = exports.ITEM_HEIGHT = exports.LEGEND_PADDING = exports.FLUID_PAGING_WIDTH = exports.RESPONSIVE_VISIBLE_ROWS = exports.RESPONSIVE_ITEM_MIN_WIDTH = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var head_1 = tslib_1.__importDefault(require("lodash/head"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var common_1 = require("../chartTypes/_util/common");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var chartCapabilities_1 = require("../chartTypes/_chartOptions/chartCapabilities");
exports.RESPONSIVE_ITEM_MIN_WIDTH = 200;
exports.RESPONSIVE_VISIBLE_ROWS = 2;
exports.FLUID_PAGING_WIDTH = 30;
exports.LEGEND_PADDING = 12;
exports.ITEM_HEIGHT = 20;
exports.SKIPPED_LABEL_TEXT = "...";
exports.UTF_NON_BREAKING_SPACE = "\u00A0";
var STATIC_PAGING_HEIGHT = 44;
function calculateFluidLegend(seriesCount, containerWidth) {
    // -1 because flex dimensions provide rounded number and the real width can be float
    var realWidth = containerWidth - 2 * exports.LEGEND_PADDING - 1;
    if (seriesCount <= 2) {
        return {
            hasPaging: false,
            itemWidth: realWidth / seriesCount,
            visibleItemsCount: seriesCount,
        };
    }
    var columnsCount = Math.floor(realWidth / exports.RESPONSIVE_ITEM_MIN_WIDTH);
    var itemWidth = realWidth / columnsCount;
    var hasPaging = false;
    var rowsCount = Math.ceil(seriesCount / columnsCount);
    // Recalculate with paging
    if (rowsCount > exports.RESPONSIVE_VISIBLE_ROWS) {
        var legendWidthWithPaging = realWidth - exports.FLUID_PAGING_WIDTH;
        columnsCount = Math.floor(legendWidthWithPaging / exports.RESPONSIVE_ITEM_MIN_WIDTH);
        itemWidth = legendWidthWithPaging / columnsCount;
        hasPaging = true;
    }
    var visibleItemsCount = columnsCount * exports.RESPONSIVE_VISIBLE_ROWS;
    return {
        itemWidth: itemWidth,
        hasPaging: hasPaging,
        visibleItemsCount: visibleItemsCount,
    };
}
exports.calculateFluidLegend = calculateFluidLegend;
function getStaticVisibleItemsCount(containerHeight, withPaging) {
    if (withPaging === void 0) { withPaging = false; }
    var pagingHeight = withPaging ? STATIC_PAGING_HEIGHT : 0;
    return Math.floor((containerHeight - pagingHeight) / exports.ITEM_HEIGHT);
}
function calculateStaticLegend(seriesCount, containerHeight) {
    var visibleItemsCount = getStaticVisibleItemsCount(containerHeight);
    if (visibleItemsCount >= seriesCount) {
        return {
            hasPaging: false,
            visibleItemsCount: visibleItemsCount,
        };
    }
    return {
        hasPaging: true,
        visibleItemsCount: getStaticVisibleItemsCount(containerHeight, true),
    };
}
exports.calculateStaticLegend = calculateStaticLegend;
var LEGEND_TEXT_KEYS = {
    column: ["left", "right"],
    line: ["left", "right"],
    bar: ["bottom", "top"],
    area: ["left", "right"],
    combo: ["left", "right"],
    combo2: ["left", "right"],
};
exports.LEGEND_AXIS_INDICATOR = "legendAxisIndicator";
exports.LEGEND_SEPARATOR = "legendSeparator";
function separateLegendItems(series) {
    return series.reduce(function (result, item) {
        // for now, it assumes that GDC chart only has 2 Y axes in maximum
        // yAxis only takes 0 (left/bottom axis) or 1 (right/top axis)
        var yAxis = item.yAxis;
        if (!yAxis) {
            // 0
            result.itemsOnFirstAxis.push(item);
        }
        else {
            result.itemsOnSecondAxis.push(item);
        }
        return result;
    }, {
        itemsOnFirstAxis: [],
        itemsOnSecondAxis: [],
    });
}
function groupSeriesItemsByType(series) {
    var _a;
    var primaryType = (_a = head_1.default(series)) === null || _a === void 0 ? void 0 : _a.type;
    return series.reduce(function (result, item) {
        if (primaryType === item.type) {
            result.primaryItems.push(item);
        }
        else {
            result.secondaryItems.push(item);
        }
        return result;
    }, {
        primaryItems: [],
        secondaryItems: [],
    });
}
exports.groupSeriesItemsByType = groupSeriesItemsByType;
function getComboChartSeries(series) {
    var _a = groupSeriesItemsByType(series), primaryItems = _a.primaryItems, secondaryItems = _a.secondaryItems;
    var primaryItem = head_1.default(primaryItems) || {};
    var secondaryItem = head_1.default(secondaryItems) || {};
    var primaryType = primaryItem.type || sdk_ui_1.VisualizationTypes.COLUMN;
    var secondaryType = secondaryItem.type || sdk_ui_1.VisualizationTypes.LINE;
    var _b = LEGEND_TEXT_KEYS.combo, firstAxisKey = _b[0], secondAxisKey = _b[1];
    // convert to dual axis series when there is only one chart type
    if (isEmpty_1.default(secondaryItems)) {
        return transformToDualAxesSeries(series, primaryType);
    }
    // all measures display on same axis
    if (primaryItem.yAxis === secondaryItem.yAxis) {
        return tslib_1.__spreadArrays([
            { type: exports.LEGEND_AXIS_INDICATOR, labelKey: primaryType }
        ], primaryItems, [
            { type: exports.LEGEND_SEPARATOR },
            { type: exports.LEGEND_AXIS_INDICATOR, labelKey: secondaryType }
        ], secondaryItems);
    }
    return tslib_1.__spreadArrays([
        {
            type: exports.LEGEND_AXIS_INDICATOR,
            labelKey: sdk_ui_1.VisualizationTypes.COMBO,
            data: [primaryType, firstAxisKey],
        }
    ], primaryItems, [
        { type: exports.LEGEND_SEPARATOR },
        {
            type: exports.LEGEND_AXIS_INDICATOR,
            labelKey: sdk_ui_1.VisualizationTypes.COMBO,
            data: [secondaryType, secondAxisKey],
        }
    ], secondaryItems);
}
exports.getComboChartSeries = getComboChartSeries;
function createDualAxesSeriesMapper(chartType) {
    return function (series) {
        return transformToDualAxesSeries(series, chartType);
    };
}
exports.createDualAxesSeriesMapper = createDualAxesSeriesMapper;
function transformToDualAxesSeries(series, chartType) {
    var _a = separateLegendItems(series), itemsOnFirstAxis = _a.itemsOnFirstAxis, itemsOnSecondAxis = _a.itemsOnSecondAxis;
    if (!common_1.isOneOfTypes(chartType, chartCapabilities_1.supportedDualAxesChartTypes) ||
        !itemsOnFirstAxis.length ||
        !itemsOnSecondAxis.length) {
        return series;
    }
    var _b = LEGEND_TEXT_KEYS[chartType], firstAxisKey = _b[0], secondAxisKey = _b[1];
    return tslib_1.__spreadArrays([
        { type: exports.LEGEND_AXIS_INDICATOR, labelKey: firstAxisKey }
    ], itemsOnFirstAxis, [
        { type: exports.LEGEND_SEPARATOR },
        { type: exports.LEGEND_AXIS_INDICATOR, labelKey: secondAxisKey }
    ], itemsOnSecondAxis);
}
exports.transformToDualAxesSeries = transformToDualAxesSeries;
function isStackedChart(chartOptions) {
    var _a, _b;
    var seriesLength = (_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _a === void 0 ? void 0 : _a.series) === null || _b === void 0 ? void 0 : _b.length;
    var type = chartOptions.type, stacking = chartOptions.stacking, hasStackByAttribute = chartOptions.hasStackByAttribute;
    var hasMoreThanOneSeries = seriesLength > 1;
    var isAreaChartWithOneSerie = common_1.isAreaChart(type) && !hasMoreThanOneSeries && !hasStackByAttribute;
    return !isAreaChartWithOneSerie && !common_1.isTreemap(type) && Boolean(stacking);
}
exports.isStackedChart = isStackedChart;
//# sourceMappingURL=legendHelpers.js.map